/** @type {Styles} */

export const styles = {
  margin: {
    marginTop: 1.5,
  },
  internalDivider: {
    borderColor: 'gray.8',
    marginTop: 0,
    marginBottom: 1.5,
  },
  openedMultiplePaymentWrapper: {},
  multiplePaymentWrapper: {
    paddingTop: 1.5,
    paddingBottom: 0,
    flexDirection: 'column',
    display: 'flex',
  },
  buttonWrapper: {
    marginBottom: 1.5,
  },
  openedSummary: {
    '& .MuiAccordionSummary-content': {
      marginBottom: 0,
    },
  },
  accordionContent: {
    '.MuiAccordionDetails-root': {
      padding: 0,
    },
    marginBottom: 0,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  accordionSummary: {
    marginLeft: 0,
    marginRight: 0,
    border: 0,
    '& .MuiAccordionSummary-content': {
      marginBottom: 1,
      marginTop: 1,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      marginRight: 0,
    },
  },
}
